import { motion } from "framer-motion";
import { brandLogo } from "../data/site";

/**
 * Brand logo — uses the actual gold building mark PNG.
 * Wrapped in a motion container so the preloader can add shimmer/fade.
 */
export default function LogoMark({ className = "", size = 44, animate = true }) {
    const inner = (
        <img
            src={brandLogo}
            alt="BRA Sheriff logo"
            width={size}
            height={size}
            className="block object-contain"
            style={{ width: size, height: size, filter: "drop-shadow(0 4px 20px rgba(200,155,60,0.35))" }}
            draggable={false}
        />
    );

    if (!animate) {
        return <div className={className}>{inner}</div>;
    }

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.85, filter: "blur(4px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.1, ease: [0.2, 0.7, 0.2, 1] }}
            className={`relative inline-block ${className}`}
            style={{ width: size, height: size }}
        >
            {inner}
            {/* Shimmer sweep overlay */}
            <motion.div
                initial={{ x: "-120%" }}
                animate={{ x: "160%" }}
                transition={{
                    duration: 1.8,
                    delay: 0.8,
                    repeat: Infinity,
                    repeatDelay: 4,
                    ease: "easeInOut",
                }}
                aria-hidden
                className="pointer-events-none absolute inset-0"
                style={{
                    background:
                        "linear-gradient(100deg, transparent 40%, rgba(255,240,200,0.55) 50%, transparent 60%)",
                    mixBlendMode: "screen",
                    maskImage: `url(${brandLogo})`,
                    WebkitMaskImage: `url(${brandLogo})`,
                    maskSize: "contain",
                    WebkitMaskSize: "contain",
                    maskRepeat: "no-repeat",
                    WebkitMaskRepeat: "no-repeat",
                    maskPosition: "center",
                    WebkitMaskPosition: "center",
                }}
            />
        </motion.div>
    );
}
